import { createSlice } from "../helper";
import * as ObjectExtensions from "../../utils/CoreExtensions/ObjectExtensions";

const meetingFrequencyPopupSlice = createSlice({
    name: 'MeetingFrequency',
    initialState: {
      groupId: null,
      stored: {
        frequencyOption: null,
        frequencyDays: null,
        startDate: null
      },
      submitPayload: {
        frequencyOption: null,
        frequencyDays: null,
        startDate: null
      }
    },
    reducers:{
      updateMeetingFrequencyPayload: (state, action) => {
        state.submitPayload = ObjectExtensions.deepMerge(state.submitPayload, action.payload);
      },
      updateStoredMeetingFrequency: (state, action) => {
        state.stored = ObjectExtensions.deepMerge(state.stored, action.payload);
      },
      setInitialMeetingFrequencyData: (state, action) => {
        state.stored = action.payload.frequencyDetails;
        state.submitPayload = action.payload.frequencyDetails;
        state.groupId = action.payload.groupId;
      }
    }
})

export const meetingFrequencyActions =  meetingFrequencyPopupSlice.actions;

export default meetingFrequencyPopupSlice;


